import { render, staticRenderFns } from "./Profile-View.vue?vue&type=template&id=507bfaa1&scoped=true&"
import script from "./Profile-View.vue?vue&type=script&setup=true&lang=js&"
export * from "./Profile-View.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Profile-View.vue?vue&type=style&index=0&id=507bfaa1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507bfaa1",
  null
  
)

export default component.exports